import { compareDate, compareMonth } from 'utils/dateUtils';
import { ICategory, IExpense } from '../../common/entities';
import { Currency, IMonth } from 'common/types';

const countInCurrency = (expense: IExpense, currency: Currency) => {
  if (!expense.amountData || expense.amountData.currency === currency) {
    return expense.amount;
  }
  return (
    Math.round(expense.amount * (expense.amountData.exchangeRate || 1) * 100) /
    100
  );
};

export function getBudgetMonthSpent(
  budgetId: string | undefined,
  expenses: IExpense[],
  month: IMonth,
  currency: Currency
) {
  return expenses.reduce((sum, current) => {
    return current.budgetId === budgetId && isExpenseInMonth(current, month)
      ? sum + countInCurrency(current, currency)
      : sum;
  }, 0);
}

export function getBudgetSpent(
  budgetId: string | undefined,
  expenses: IExpense[],
  currency: Currency
) {
  return expenses.reduce((sum, current) => {
    return current.budgetId === budgetId ? sum + countInCurrency(current, currency) : sum;
  }, 0);
}

export function getCategorySpent(
  categoryId: string | undefined,
  expenses: IExpense[],
  categories: ICategory[],
  month: IMonth,
  currency: Currency,
  includeSubcategories = false
) {
  const subcategoriesIds =
    categoryId && includeSubcategories
      ? categories
          .filter(cat => cat.parentCategoryId === categoryId)
          .map(cat => cat.id)
      : [];
  return expenses.reduce((sum, current) => {
    return (current.categoryId === categoryId ||
      (current.categoryId && subcategoriesIds.includes(current.categoryId))) &&
      isExpenseInMonth(current, month)
      ? sum + countInCurrency(current, currency)
      : sum;
  }, 0);
}

export function isExpenseInMonth(expense: IExpense, month: IMonth) {
  const expenseDate = new Date(expense.date);
  const monthDate = new Date(month.year, month.month);
  return compareMonth(expenseDate, monthDate);
}

export function getExpenseMonthTotal(
  expenses: IExpense[],
  month: IMonth,
  currency: Currency
) {
  return expenses.reduce((sum, current) => {
    return isExpenseInMonth(current, month)
      ? sum + countInCurrency(current, currency)
      : sum;
  }, 0);
}

export function getExpenseDayTotal(
  expenses: IExpense[],
  date: Date,
  currency: Currency
) {
  return expenses.reduce((sum, current) => {
    return compareDate(new Date(current.date), date)
      ? sum + countInCurrency(current, currency)
      : sum;
  }, 0);
}
